package br.com.texeratx.boardgametimeapp.core.image

data class PickedImage(
    val bytes: ByteArray,
    val fileName: String,
    val mimeType: String
)
